// removed by extract-text-webpack-plugin
module.exports = {"wrap":"IndustryCode-hashed__wrap__3QY4m","textStyle":"IndustryCode-hashed__textStyle__1o5RU"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/typeahead/matchContentDirectives/IndustryCode/IndustryCode-hashed.scss
// module id = 1226
// module chunks = 0